export default {"src":"https://fishbrain.com/_next/static/media/gar.cb9365ba.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};